import React from 'react';
import { Outlet, Route, Routes } from "react-router-dom";
import AppShell from 'components/AppShell';
import PersonalizedInterviewScreen from 'screens/PersonalizedInterviewScreen';
import PersonalizedInterviewPerformance from 'components/PersonalizedInterview/PersonalizedInterviewPerformance';
import ShortlistingPerformance from 'components/PersonalizedInterview/ShortlistingPerformance';
import PersonalizedCodingPerformance from 'components/PersonalizedInterview/PersonalizedCodingPerformance';

function PersonalizedInterview(props) {
  return (
    <Routes>
      <Route path="/" element={<PersonalizedInterviewLayout />}>
        <Route
          index
          element={
            <React.Suspense fallback={<>...</>}>
              <PersonalizedInterviewScreen/>
            </React.Suspense>
          }
        />
        <Route
          path="/:id/performance/next-round"
          element={
            <React.Suspense fallback={<>...</>}>
              <PersonalizedInterviewPerformance />
            </React.Suspense>
          }
        />
        <Route
          path="/:id/performance/coding-round"
          element={
            <React.Suspense fallback={<>...</>}>
              <PersonalizedCodingPerformance />
            </React.Suspense>
          }
        />
        <Route
          path="/:id/performance/shortlist-genie"
          element={
            <React.Suspense fallback={<>...</>}>
              <ShortlistingPerformance />
            </React.Suspense>
          }
        />
      </Route>  
    </Routes>
  );
}

export default PersonalizedInterview;

function PersonalizedInterviewLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}